import type { ListenerTypes } from '../types';

export const defaultListenerTypes: ListenerTypes = {
  create: true,
  edit: true,
  delete: true,
};

/*
 * How much of the selected feature can be given editable vertex handles at the current zoom.
 */
export enum EditingLock {
  // Every vertex is reachable.
  None = 'none',
  // Some vertices are out of reach, but the feature can still be edited.
  Partial = 'partial',
  // Too dense to render any handle — the feature cannot be edited at all.
  Hidden = 'hidden',
}
